module.exports = __webpack_public_path__ + "img/tick.db22f322.png";